let store = require("../store");
let actions = require("../actions");

let QuestionEditor = require("../widget/QuestionEditor");

let FormRange = mc.widgets.FormRange;
let FormControls = mc.widgets.FormControls;
let FormFeedback = mc.widgets.FormFeedback;

class DiaryFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      diary: mc.utils.clone(this.props.diary),
      errors: [],
      submitting: false
    };
  }

  setDisplayName(evt) {
    this.mutate("displayName", evt.target.value);
  }

  setQuestions(questions) {
    this.mutate("questions", questions);
  }

  mutate(fieldName, fieldValue) {
    let diary = mc.utils.clone(this.state.diary);
    diary[fieldName] = fieldValue;

    this.setState({ diary });
  }

  saveDiary() {
    let diary = this.state.diary;
    let method = diary.id ? "UPDATE" : "CREATE";

    actions.saveDiary(diary, method).then((function (payload) {
      if (payload.errors.length) {
        this.setState({
          errors: payload.errors,
          submitting: false
        });
      }
      else {
        mc.ui.modal(null);
        actions.loadStudy(payload.diary.studyId);
      }
    }).bind(this));

    this.setState({
      submitting: true
    });
  }

  cancel() {
    mc.ui.modal(null);
  }

  deleteDiary() {
    let diary = this.state.diary;

    mc.ui.alert(tx("delete_diary"), {
      level: "warn",
      mode: "confirm",
      labels: {
        confirm: tx("delete"),
        cancel: tx("cancel")
      },
      onHide: (function (confirmed) {
        if (confirmed) {
          actions.saveDiary(diary, "DELETE").then((function (payload) {
            if (payload.errors.length) {
              this.setState({
                errors: payload.errors,
                submitting: false
              });
            }
            else {
              mc.ui.modal(null);
              rc.actions.loadStudy(diary.studyId);
            }
          }).bind(this));
        }

        this.setState({
          submitting: true
        });
      }).bind(this)
    });
  }

  isValid() {
    let diary = this.state.diary;

    return (
      diary.displayName.trim().length > 0 &&
      diary.questions.length > 0 &&
      diary.questions.every(function (question) {
        if (!question.text.trim().length) {
          return false;
        }

        if (question.type === "MULTIPLECHOICE") {
          if (question.values.length < 2 || question.values.some((v) => v.trim().length === 0)) {
            return false;
          }
        }

        return true;
      })
    );
  }

  static open(diary, disabled) {
    let form = <DiaryFormView diary={diary} disabled={disabled}/>;

    mc.ui.modal(form, { width: "80%", height: "90%", dismissable: disabled });
  }

  render() {
    let diary = this.state.diary;
    let disabled = this.props.disabled;

    if (!diary) {
      return null;
    }

    return (
      <div className="rc-diary-form-view">
        <h1>{diary.id ? (diary.displayName || "...") : tx("new_diary")}</h1>
        <div>
          <section>
            <h2>{tx("diary_name")}</h2>
            <input name="displayName" type="text" size="32" maxLength="64" value={diary.displayName} onChange={this.setDisplayName.bind(this)} disabled={disabled}/>
          </section>
          <section>
            <h2>{tx("questions")}</h2>
            <QuestionEditor questions={diary.questions} onEdit={this.setQuestions.bind(this)} disabled={disabled}/>
          </section>
          <FormFeedback errors={this.state.errors}/>
          <FormControls
            onSave={this.saveDiary.bind(this)}
            onCancel={this.cancel.bind(this)}
            onDelete={!disabled && diary.id && this.deleteDiary.bind(this)}
            enabled={!disabled && this.isValid() && !this.state.submitting}/>
        </div>
      </div>
    );
  }
}

module.exports = DiaryFormView;